export enum ObjectiveTypeEnum {
  'BRAND_AWARENESS_AND_REACH' = 'BRAND_AWARENESS_AND_REACH',
  'WEB_SITE_TRAFFIC' = 'WEB_SITE_TRAFFIC',
  'APP_PROMOTION_AND_INSTALL' = 'APP_PROMOTION_AND_INSTALL',
  'LOCAL_STORE_PROMOTIONS' = 'LOCAL_STORE_PROMOTIONS',
  'GENERATION_DE_PROSPECTS' = 'GENERATION_DE_PROSPECTS',
}

export const ObjectiveTypeEnumMapping: Record<ObjectiveTypeEnum, string> = {
  [ObjectiveTypeEnum.BRAND_AWARENESS_AND_REACH]: 'enumMapping.objectives.BRAND_AWARENESS_AND_REACH',
  [ObjectiveTypeEnum.WEB_SITE_TRAFFIC]: 'enumMapping.objectives.WEB_SITE_TRAFFIC',
  [ObjectiveTypeEnum.APP_PROMOTION_AND_INSTALL]: 'enumMapping.objectives.APP_PROMOTION_AND_INSTALL',
  [ObjectiveTypeEnum.LOCAL_STORE_PROMOTIONS]: 'enumMapping.objectives.LOCAL_STORE_PROMOTIONS',
  [ObjectiveTypeEnum.GENERATION_DE_PROSPECTS]: 'enumMapping.objectives.GENERATION_DE_PROSPECTS',
};
export const ObjectiveMapping: Record<string, ObjectiveTypeEnum> = {
  ['enumMapping.objectives.BRAND_AWARENESS_AND_REACH'] : ObjectiveTypeEnum.BRAND_AWARENESS_AND_REACH,
  ['enumMapping.objectives.WEB_SITE_TRAFFIC'] :ObjectiveTypeEnum.WEB_SITE_TRAFFIC,
  ['enumMapping.objectives.APP_PROMOTION_AND_INSTALL'] : ObjectiveTypeEnum.APP_PROMOTION_AND_INSTALL,
  ['enumMapping.objectives.LOCAL_STORE_PROMOTIONS']: ObjectiveTypeEnum.LOCAL_STORE_PROMOTIONS,
  ['enumMapping.objectives.GENERATION_DE_PROSPECTS'] : ObjectiveTypeEnum.GENERATION_DE_PROSPECTS
};

export const HashedObjectiveEnum: Record<ObjectiveTypeEnum, string> = {
  [ObjectiveTypeEnum.BRAND_AWARENESS_AND_REACH]: 'XnK7zq',
  [ObjectiveTypeEnum.WEB_SITE_TRAFFIC]: 'Jw8pRz',
  [ObjectiveTypeEnum.APP_PROMOTION_AND_INSTALL]: 'Ee3fXn',
  [ObjectiveTypeEnum.LOCAL_STORE_PROMOTIONS]: 'Fg9eQs',
  [ObjectiveTypeEnum.GENERATION_DE_PROSPECTS]: 'Dn5pJf',
};

export const MappingObjectiveEnum_CLICKUP: Record<ObjectiveTypeEnum, string> = {
  [ObjectiveTypeEnum.BRAND_AWARENESS_AND_REACH]: '8e7fe505-6a1c-4cea-83c3-dd989bd63776',
  [ObjectiveTypeEnum.WEB_SITE_TRAFFIC]: 'd8dbd420-a170-4f75-adfc-cdc5b0dac704',
  [ObjectiveTypeEnum.APP_PROMOTION_AND_INSTALL]: '4b0ba9f4-d9d2-4eab-a190-bdb3760313c3',
  [ObjectiveTypeEnum.LOCAL_STORE_PROMOTIONS]: 'e31b094d-17d7-43b3-a3fb-8b212e2eb238',
  [ObjectiveTypeEnum.GENERATION_DE_PROSPECTS]: '98efa809-e9d4-4f35-bf85-dced250b6ed3',
};
export interface ObjectiveStatusInterface {
  id: ObjectiveTypeEnum;
  value: string;
}
